// Mock data for Green Coke and Energy website
import natarajanImage from '../assets/natarajan.jpeg';

export const companyInfo = {
  name: 'Green Metallurgical Coke and Green Energy Pvt. Ltd.',
  tagline:
    'Premium Metallurgical Coke & Green Energy Solutions for Industrial Excellence',
  description:
    "Green Coke and Energy is a pioneering Metallurgical Coke manufacturing and Green Energy trading company currently in its commissioning phase. We specialize in producing premium-quality, low ash, low phosphorus coke products designed to meet the exacting standards of India's steel, ferro-alloy, and foundry industries.",
  mission:
    "To deliver premium-quality Metallurgical Coke and Green Energy solutions that drive industrial excellence across India's manufacturing sectors.",
  vision:
    "To become the preferred Metallurgical Coke supplier and Green Energy trading partner for India's largest industrial enterprises.",
  values: [
    {
      title: 'Quality First',
      description:
        'Uncompromising commitment to meeting stringent industry specifications and exceeding customer expectations.',
    },
    {
      title: 'Reliability',
      description:
        'Consistent supply chain management and dependable partnerships built on trust and transparency.',
    },
    {
      title: 'Sustainability',
      description:
        'Environmentally responsible operations with a focus on compliance and sustainable practices.',
    },
    {
      title: 'Innovation',
      description:
        'Adoption of advanced technology and modern manufacturing processes for superior quality.',
    },
  ],
  contact: {
    address: {
      line1: 'Green Metallurgical Coke and Green Energy Pvt. Ltd.',
      line2: 'Industrial Area, Sector 5',
      city: 'Mumbai',
      state: 'Maharashtra',
      pincode: '400001',
      country: 'India',
    },
    phones: {
      main: '+91 22 1234 5678',
      trading: '+91 22 1234 5679',
      general: '+91 22 1234 5680',
    },
    emails: {
      general: 'info@greencokeenergy.com',
      trading: 'trading@greencokeenergy.com',
      hr: 'careers@greencokeenergy.com',
    },
    hours: {
      weekdays: 'Monday-Friday: 9 AM - 6 PM IST',
      saturday: 'Saturday: 9 AM - 2 PM IST',
      sunday: 'Sunday: Closed',
    },
  },
  social: {
    linkedin: 'https://www.linkedin.com/company/greencokeenergy',
    twitter: 'https://twitter.com/greencokeenergy',
    facebook: 'https://facebook.com/greencokeenergy',
  },
};

export const leadership = [
    {
      name: 'Natarajan Mahalingam',
      title: 'Founder & Managing Director',
      bio: 'Natarajan brings over 25 years of experience in industrial manufacturing and supply chain management. His expertise in metallurgical processes and strategic business development drives our commitment to quality and operational excellence.',
      image:natarajanImage,
      linkedin: 'https://www.linkedin.com/in/natarajan-mahalingam-8944b3357/',
    },
  // {
  //   name: "Eshwin Iyer Natarajan",
  //   title: "Director - Operations",
  //   bio: "With extensive experience in industrial operations and process optimization, Eshwin leads our manufacturing strategy and quality assurance initiatives. His focus on sustainable practices ensures our operations meet the highest industry standards.",
  //   image: null,
  //   linkedin: "#"
  // },
  // {
  //   name: 'Harold Antony Gomez',
  //   title: 'Director - Trading & Business Development',
  //   bio: "Harold brings deep expertise in energy trading and strategic partnerships. He oversees our trading operations and business development initiatives, ensuring we deliver comprehensive solutions to our clients across India's industrial sectors.",
  //   image: null,
  //   linkedin: '#',
  // },
];

export const products = [
  {
    id: 'coke',
    title: 'Metallurgical Coke Products',
    description:
      'Premium Metallurgical Coke products designed for steel manufacturing, ferro-alloy production, and foundry applications.',
    features: [
      'Low Ash Metallurgical (LAM) Coke',
      'Nut Metallurgical Coke with Ultra Low Phosphorus',
      'Metallurgical Coke Breeze & Fines',
      'Customizable grade specifications',
    ],
    icon: 'Factory',
  },
  {
    id: 'trading',
    title: 'Green Energy Trading',
    description:
      'Comprehensive Metallurgical Coke procurement and supply chain solutions with market intelligence and logistics optimization.',
    features: [
      'Bulk trading operations',
      'Supply chain optimization',
      'Market intelligence & analytics',
      'Customized supply agreements',
    ],
    icon: 'TrendingUp',
  },
  // {
  //   id: 'development',
  //   title: 'Project Development',
  //   description:
  //     'Currently in commissioning phase with state-of-the-art manufacturing facility expected to be operational by Q4 2025.',
  //   features: [
  //     'Modern manufacturing infrastructure',
  //     'Environmental compliance focus',
  //     'Quality control systems',
  //     'Planned capacity expansion',
  //   ],
  //   icon: 'Building2',
  // },
];

export const cokeGrades = [
  {
    grade: 'LAM Metallurgical Coke +100mm',
    size: '+100mm',
    ash: '12.5% max',
    phosphorus: '0.05% max',
    sulfur: '0.6% max',
    application: 'Blast Furnaces',
  },
  {
    grade: 'LAM Metallurgical Coke 70-100mm',
    size: '70-100mm',
    ash: '12.5% max',
    phosphorus: '0.05% max',
    sulfur: '0.6% max',
    application: 'Mixed Applications',
  },
  {
    grade: 'LAM Metallurgical Coke 20-80mm',
    size: '20-80mm',
    ash: '12.5% max',
    phosphorus: '0.05% max',
    sulfur: '0.6% max',
    application: 'General Industrial',
  },
  {
    grade: 'Nut Metallurgical Coke 10-30mm',
    size: '10-30mm',
    ash: '13.5% max',
    phosphorus: '0.01% max',
    sulfur: '0.6% max',
    application: 'Ferro-Alloy',
  },
  {
    grade: 'Ultra Low Phos Nut',
    size: '10-30mm',
    ash: '13.5% max',
    phosphorus: '0.01% max',
    sulfur: '0.6% max',
    application: 'Special Steel',
  },
  {
    grade: 'Metallurgical Coke Breeze/Fines',
    size: '<20mm',
    ash: '20-25%',
    phosphorus: '0.05% max',
    sulfur: '0.6% max',
    application: 'Sintering Plants',
  },
];

export const timeline = [
  {
    phase: "Company Formation",
    status: "completed",
    date: "Q1 2024",
    description: "Legal registration and licensing completed"
  },
  {
    phase: "Project Planning",
    status: "completed",
    date: "Q2 2024",
    description: "Facility design and technology selection finalized"
  },
  {
    phase: "Infrastructure Development",
    status: "in-progress",
    date: "Q3-Q4 2024",
    description: "Civil construction and equipment procurement underway"
  },
  {
    phase: "Commissioning Phase",
    status: "planned",
    date: "Q4 2025",
    description: "Equipment installation and testing scheduled"
  },
  {
    phase: "Commercial Operations",
    status: "planned",
    date: "2026",
    description: "Full-scale production launch targeted"
  }
];

export const tradingServices = [
  {
    title: 'Metallurgical Coke Procurement & Supply',
    points: [
      'Bulk trading operations',
      'Direct supplier relationships',
      'Market-competitive pricing',
    ],
  },
  {
    title: 'Supply Chain Optimization',
    points: [
      'Logistics coordination',
      'Transportation management',
      'Inventory optimization',
    ],
  },
  {
    title: 'Market Intelligence',
    points: [
      'Price trends and analysis',
      'Availability forecasting',
      'Supplier network access',
    ],
  },
  {
    title: 'Customized Solutions',
    points: [
      'Tailored supply agreements',
      'Volume-based arrangements',
      'Long-term partnerships',
    ],
  },
];

export const whyChooseUs = [
  {
    title: 'Expertise & Experience',
    description:
      'Backed by seasoned professionals with decades of experience in Metallurgical Coke manufacturing and industrial supply chains.',
  },
  {
    title: 'Quality Commitment',
    description:
      'Rigorous quality control processes ensuring consistent specifications and meeting the highest industry standards.',
  },
  {
    title: 'Operational Excellence',
    description:
      'State-of-the-art infrastructure and modern manufacturing processes designed for efficiency and reliability.',
  },
  {
    title: 'Sustainability Focus',
    description:
      'Environmental compliance from day one with commitment to sustainable industrial practices and regulatory adherence.',
  },
];

export const faqs = [
  {
    category: 'General',
    question:
      'When will Green Metallurgical Coke and Green Energy start commercial operations?',
    answer:
      'We are currently in the commissioning phase with our manufacturing facility under development. We expect to commence commercial operations by Q4 2025, with full-scale production targeted for 2026. Our trading services are already available for clients seeking Metallurgical Coke procurement and supply chain solutions.',
  },
  {
    category: 'Products',
    question: 'What is Low Ash Metallurgical (LAM) Coke?',
    answer:
      'LAM Metallurgical Coke is premium-grade Metallurgical Coke with significantly reduced ash content (typically 12.5% or lower). This superior quality Metallurgical Coke is essential for blast furnace operations as it improves efficiency, reduces slag formation, and enhances overall steel quality. Our LAM Metallurgical Coke also features low phosphorus and sulfur content, meeting the strictest industry specifications.',
  },
  {
    category: 'Products',
    question: 'What Metallurgical coke grades do you offer?',
    answer:
      'We offer a comprehensive range of Metallurgical Coke products including: LAM Metallurgical Coke in various sizes (+100mm, 70-100mm, 20-80mm), Nut Metallurgical Coke (10-30mm) with ultra-low phosphorus options for ferro-alloy and special steel applications, and Metallurgical Coke Breeze/Fines for sintering plants. All grades can be customized to meet specific customer requirements.',
  },
  {
    category: 'Supply',
    question: 'Do you offer bulk trading services?',
    answer:
      'Yes, we provide comprehensive Green Energy trading services including bulk Metallurgical Coke procurement and supply, supply chain optimization, logistics coordination, and market intelligence. Our trading division is operational and ready to serve clients with immediate requirements while our manufacturing facility is being commissioned.',
  },
  {
    category: 'General',
    question: 'What certifications will you have?',
    answer:
      'We are actively pursuing all necessary certifications including ISO 9001:2015 for quality management, environmental compliance certifications from CPCB/SPCB, and industry-specific certifications. Our quality control systems and testing protocols are being developed to meet international standards. All certifications are planned to be in place before commercial operations commence.',
  },
  {
    category: 'Supply',
    question: 'Which industries do you serve?',
    answer:
      'We serve multiple industrial sectors including integrated steel plants and mini steel mills, ferro-alloy production facilities, foundries and casting operations, and sintering plants. Our products are designed for applications in blast furnaces, foundry operations, and specialized metallurgical processes.',
  },
];